// //for client testing and demos
export const API_LoginURL = "https://xr4stem-g5e7frazcqajdwcr.centralindia-01.azurewebsites.net/apigateway/";
export const API_courseURL ="https://xr4stem-g5e7frazcqajdwcr.centralindia-01.azurewebsites.net/courseserviceapi/";
export const API_BannerURL ="https://xr4stem-g5e7frazcqajdwcr.centralindia-01.azurewebsites.net/userserviceapi/";
export const Img_APIURL ="https://xr4stem-g5e7frazcqajdwcr.centralindia-01.azurewebsites.net/courseserviceapi";

// for client testing and demos
// export const API_LoginURL = "http://4.188.88.117:5000/";
// export const API_courseURL ="http://4.188.88.117:5002/";
// export const API_BannerURL ="http://4.188.88.117:5001/";
// export const Img_APIURL ="http://4.188.88.117:5002";

// for UAT
// export const API_LoginURL = "http://4.188.88.117:5006/";
// export const API_courseURL ="http://4.188.88.117:5004/";
// export const API_BannerURL ="http://4.188.88.117:5005/";
// export const Img_APIURL ="http://4.188.88.117:5004";

